export interface TrackerConfig {
  mode: string
  color: number
  icon: number
  notify_position: boolean
  notify_long_walk: boolean
  network: string
  network_region: string
  network_config?: number
  firmware_path: string
  board_name: string
  usage?: string
  image?: string
  requested_mode?: string
  requested_mode_updated?: string
}

export interface TrackerStatus {
  battery: number
  begin_date: string
  last_event: string
  state: string
  sub_end_date?: string
  sub_state?: string
  sub_type?: SubType
  last_location?: string
  network_operator?: string
  stationary: number
  boost_state: number
  last_loc_latitude?: number
  last_loc_longitude?: number
  last_loc_accuracy?: number
  lost_pending?: boolean
  lost?: boolean
  pre_installed?: boolean
}

/**
 * Enumeration of device sub-types.
 */
export enum SubType {
  lite = 'basic',
  plus = 'plus',
  max = 'max GPS',
  unknown = 'unknown',
}

export interface Device {
  id: number
  name: string
  type: 'tracker_01' | 'tracker_02' | 'tracker_03' | 'tracker_04' | 'tracker_06' | 'tracker_07' | 'LWT2' | 'SCT2' | 'SCT2V2'
  serial: string
  created: string
  model?: string
  version_build: string
  timezone: string
  version: string
  caps?: {
    collect?: boolean
    autocollect?: boolean
  }
  tracker_config: TrackerConfig
  tracker_status: TrackerStatus
}
